// Source: app/scripts/controllers/user-profile.js
/**
 * Created by ristes on 20.4.15.
 */

Auction.controller('UserProfileController', [
  '$scope',
  '$modal',
  '$filter',
  '$location',
  'toaster',
  'crudService',
  'Auth',
  '$window',
  'Downloader',
  '$timeout',
  'UserService',
  'Messages',
  function ($scope, $modal, $filter, $location, toaster, crudService, Auth, $window, Downloadery, $timeout, UserService, Messages) {

    $scope.mfaStatus = {enabled: false, backupCodesRemaining: 0, mfaSetupRequired: false};
    $scope.mfaSetup = {};
    // Object wrapper avoids ng-include/ng-if scope shadowing for primitive ng-model values.
    $scope.mfaForm = {confirmCode: '', disablePassword: '', regeneratePassword: ''};
    $scope.mfaBackupCodes = [];
    $scope.showTwoFactor = false;

    function loadMfaStatus() {
      UserService.getMfaStatus(function (status) {
        $scope.mfaStatus = status || {enabled: false, backupCodesRemaining: 0, mfaSetupRequired: false};
        if (($scope.$root.user && $scope.$root.user.mfaSetupRequired) || $scope.mfaStatus.mfaSetupRequired) {
          $scope.showTwoFactor = true;
        }
      });
    }

    function showBackupCodes(codes) {
      $scope.mfaBackupCodes = codes || [];
    }

    $scope.beginTwoFactorSetup = function () {
      UserService.setupMfa({}, function (setup) {
        $scope.mfaSetup = setup || {};
        $scope.mfaForm.confirmCode = '';
        $scope.mfaBackupCodes = [];
      });
    };

    $scope.confirmTwoFactorSetup = function () {
      var code = ($scope.mfaForm.confirmCode || '').replace(/\s+/g, '');
      if (code.length !== 6) {
        toaster.pop('error', $filter('translate')('generic.error'),
          $filter('translate')('auth.mfa_invalid'));
        return;
      }
      UserService.confirmMfa({
        code: code,
        setupKey: $scope.mfaSetup.manualEntryKey
      }, function (status) {
        $scope.mfaStatus = status || {enabled: true, backupCodesRemaining: 0, mfaSetupRequired: false};
        $scope.mfaSetup = {};
        $scope.mfaForm.confirmCode = '';
        showBackupCodes(status && status.backupCodes);
        if ($scope.$root.user) {
          $scope.$root.user.mfaSetupRequired = false;
          $scope.$root.user.twoFactorEnabled = true;
        }
        Messages.saved();
      });
    };

    $scope.disableTwoFactor = function () {
      if (!$window.confirm($filter('translate')('auth.mfa_disable_confirm'))) {
        return;
      }
      UserService.disableMfa({password: $scope.mfaForm.disablePassword}, function (status) {
        $scope.mfaStatus = status || {enabled: false, backupCodesRemaining: 0};
        $scope.mfaSetup = {};
        $scope.mfaForm.disablePassword = '';
        $scope.mfaBackupCodes = [];
        Messages.saved();
      });
    };

    $scope.copyBackupCodes = function () {
      var text = ($scope.mfaBackupCodes || []).join('\n');
      if (!text) {
        return;
      }
      if ($window.navigator && $window.navigator.clipboard && $window.navigator.clipboard.writeText) {
        $window.navigator.clipboard.writeText(text).then(function () {
          toaster.pop('success', $filter('translate')('success'),
            $filter('translate')('auth.mfa_backup_codes_copied'));
        }, function () {
          copyBackupCodesFallback(text);
        });
        return;
      }
      copyBackupCodesFallback(text);
    };

    function copyBackupCodesFallback(text) {
      var textarea = $window.document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      $window.document.body.appendChild(textarea);
      textarea.select();
      var copied = false;
      try {
        copied = $window.document.execCommand('copy');
      } catch (e) {
        copied = false;
      }
      $window.document.body.removeChild(textarea);
      if (copied) {
        toaster.pop('success', $filter('translate')('success'),
          $filter('translate')('auth.mfa_backup_codes_copied'));
      }
    }

    $scope.regenerateBackupCodes = function () {
      UserService.regenerateBackupCodes({password: $scope.mfaForm.regeneratePassword}, function (status) {
        $scope.mfaStatus = status || $scope.mfaStatus;
        $scope.mfaForm.regeneratePassword = '';
        showBackupCodes(status && status.backupCodes);
        Messages.saved();
      });
    };








    var service = crudService('user', {
      changePassword: {
        method: 'POST',
        url: '/data/rest/user/change_password'
      },
      updateData: {
        method: 'POST',
        url: '/data/rest/user/update_data'
      },
      editCompanyData: {
        method: 'POST',
        url: '/data/rest/companies/update',
        isArray: false
      },
      editIndividualData: {
        method: 'POST',
        url: '/data/rest/individuals/update',
        isArray: false
      }
    });

    var users = crudService('users', {
      findByUsername: {
        method: 'GET',
        url: '/data/rest/users/by_username/:username'
      }
    });

    var person = crudService('persons', {
      updatePersonData: {
        method: 'POST',
        url: '/data/rest/persons/update_data'
      }
    });

    var trader = crudService('traders', {
      updateTraderData: {
        method: 'POST',
        url: '/data/rest/traders/update_data'
      }
    });

    var message = localStorage.getItem('passwordExpiredMessage');
    //debugger;
    if (message) {
      toaster.pop({
        type: 'warning',
        title: $filter('translate')('generic.warning'),
        body: message,
        timeout: 0
      });
      $timeout(function() {
        localStorage.removeItem('passwordExpiredMessage');
      }, 1000);
    }


    // $scope.logout = function () {
    //   Auth.logout();
    // }

    $scope.updatePassword = function () {

      if ($scope.entity.password !== $scope.entity.confirmPassword) {
        toaster.pop('error', $filter('translate')('error'), $filter(
          'translate')('eauction.confirm_password_missmatch'));
      } else {
        service.changePassword({
          username: $scope.entity.username,
          password: $scope.entity.password,
          oldPassword: $scope.entity.oldPassword
        }, function () {
          toaster.pop('success', $filter('translate')('success'), $filter(
            'translate')('eauction.password_changed'));
          Auth.logout();
        });
      }
    };


    $scope.updateData = function () {
      // $scope.temUser = entity.registeredUserType;
      service.updateData({
        username: $scope.$root.user.username,
        lang: $scope.entity.lang,
        email: $scope.entity.email,
        phone: $scope.entity.phone

      }, function (data) {
        toaster.pop('success', $filter('translate')('success'), $filter(
          'translate')('eauction.data_updated'));
        $scope.entity = data;
        $window.location.reload();
      });

    };

    $scope.updatePersonData = function () {
      person.updatePersonData({
        username: $scope.entity.username,
        address: $scope.entity.address,
        phone: $scope.entity.phone,
        city: $scope.entity.city
      }, function (data) {
        toaster.pop('success', $filter('translate')('success'), $filter(
          'translate')('eauction.data_updated'));
        $scope.entity = data;
        $window.location.reload();
      });

    };

    $scope.updateTraderData = function () {
      trader.updateTraderData({
        id: $scope.entity.id,
        phone: $scope.entity.phone
      }, function (data) {
        toaster.pop('success', $filter('translate')('success'), $filter(
          'translate')('eauction.data_updated'));
        $scope.entity = data;
        $window.location.reload();
      });
    };

    // update license types
    var licenseTypeService = crudService('trader_license_types', {
      'update': {
        method: 'POST',
        url: '/data/rest/attachments/trader_license_type_attachment/:id/update'
      }
    });

    $scope.modalAddOrEditLicenceType = $modal({
      scope: $scope,
      template: 'forms/admin/auth/trader_licence_type.html',
      show: false
    });

    $scope.addLicenceType = function(){
      $scope.tlt = {};
      $scope.modalAddOrEditLicenceType.show();
    };




    $scope.tlt = {};
    $scope.licenseTypeUpload = {};

    $scope.editLicenseType = function (attachment, bean) {
      licenseTypeService.get({id: attachment.objectId}, function (lt) {
        $scope.tlt.traderLicenseTypeId = lt.id;
        $scope.tlt.licenseType = lt.licenseType;
        $scope.tlt.licenseValidFrom = lt.validFrom;
        $scope.tlt.licenseValidTo = lt.validTo;
        $scope.tlt.attachmentId = attachment.id;
        $scope.tltattachment = attachment;
      });
    };
    $scope.updateTraderLicenseType = function (attachment, bean) {
      licenseTypeService.update({
        id: $scope.tltattachment.objectId
      }, {
        licenseType: $scope.tlt.licenseType,
        validFrom: $scope.tlt.licenseValidFrom,
        validTo: $scope.tlt.licenseValidTo
      }, function () {
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("action.saved"));
        $scope.finishEditing();
        $scope.licenseTypeUpload.scope.reload();
      });
    };
    $scope.finishEditing = function () {
      $scope.tlt = {};
    };




    $scope.editCompanysData = function () {
      service.editCompanyData(
        $scope.userCompany,



       function (data) {

        $scope.userCompany = {};
        $window.location.reload();
      });

    };


    $scope.editIndividualData = function () {
      service.editIndividualData(
        $scope.userIndividual,



        function (data) {

          $scope.userIndividual = {};
          $window.location.reload();
        });

    };


$scope.afterLicenseTypeInit = function(crudScope){
  crudScope.editLicenceType = function(entity){
    $scope.tlt = entity;
    $scope.modalAddOrEditLicenceType.show();
    crudScope.reload();
  };
  crudScope.downloadTraderLicenceTypeAttachment = function(attachmentId){
    Downloader.download('/data/rest/attachments/' + attachmentId);
  }
};
initEntity();

    function initEntity() {

      if ($scope.$root.user) {
        users.findByUsername({
          username: $scope.$root.user.username
        }, function (data) {
          $scope.entity =data;
          $scope.userCompany = $scope.entity.company;
          $scope.userIndividual = $scope.entity.individual;
          loadMfaStatus();

        });



      } else {
        Auth.getUser(function (u) {
          $scope.entity = users.findByUsername({
            username: u.username
          });
          $scope.userCompany = $scope.entity.company;
          $scope.userIndividual = $scope.entity.individual;

        });
      }



    }

  }




]);
